import React from "react";
import { AmlExplanatoryNotes2 } from "../../reportSections/aml/amlExplanatoryNotes";
import { apiGet, apiPost } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from "react-redux";
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { popupActions } from '../../../store/popupStore';
import { Redirect } from 'react-router';
import { registrySearchActions, REGISTRY, getDataHash } from '../../../store/ceeSearchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import AmlGlobalEval from "../../reportSections/aml/amlGlobalEval";
import AmlReportDateInformation from "./amlReportDateInformation";
import AmlReportStatus, { amlReportStatus } from "../../reportSections/aml/amlReportStatus";
import classnames from "classnames";
import IdentData from "../../reportSections/identData";
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import OldStyleSection from '../../common/oldStyleSection';
import SvgRefresh from "../../../img/icons/Refresh";
import { PngFlag } from '../../common/pngFlag';
import RelationLink from '../../reportSections/relations/relationLink';
import AmlStatutoriesEval from "../../reportSections/aml/amlStatutoriesEval";
import AmlKeyOwnersEval from "../../reportSections/aml/amlKeyOwnersEval";
import AmlBeneficialOwnersEval from "../../reportSections/aml/amlBeneficialOwnersEval";
import Semaphore from '../../reportSections/aml/semaphore';
import AmlDetailData from "../../reportSections/aml/amlDetailData";
import AmlSupervisoryBoardEval from "../../reportSections/aml/amlSupervisoryBoardEval";
import AmlPublicFunctionsEval from "../../reportSections/aml/amlPublicFunctionsEval";
import AmlFinalOwnersEval from "../../reportSections/aml/amlFinalOwnersEval";

import "./aml.scss"

class AmlPath extends React.Component {

    state = {
        data: null,
        dataHash: null,
        loading: false,
        responseData: null,
        refreshReqInit: false,
        subject: null
    }

    render() {
        if (this.state.loading)
            return <Circles />;

        if (isNullOrUndefined(this.state.data))
            return <NoDataComponent />;

        if (this.state.refreshReqInit && this.props.cee[REGISTRY.aml].requestResult)
            return <Redirect to='/search/aml/results' />;

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <>
                {this.state.data !== null && this.state.loading === false && this.renderContent(this.props.asReport === true)}
                <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray"><Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} /></div>
                </div>
            </>
        )
    }

    renderContent(asReport) {
        if (asReport) {
            return (
                <>
                    {this.renderErrors()}
                    {this.areAvailable(this.state.data) && this.renderInfo()}
                    <div className={classnames("card", { "card-special": !this.areAvailable(this.state.data) })}>
                        <div className="card-body">
                            <AmlReportStatus
                                data={this.state.data}
                                dataHash={this.state.dataHash}
                                onNotRequested={() => this.requestData()}
                                onInProgress={() => this.getData()}
                                asReport={this.props.asReport}
                            >
                                {this.renderAmlData()}
                            </AmlReportStatus>
                        </div>
                    </div>
                </>
            )
        }

        return (
            <>
                {this.renderErrors()}
                {this.renderInfo()}
                <div className="card">
                    <div className="card-body">
                        {this.renderAmlData()}
                    </div>
                </div>
            </>
        );
    }

    renderInfo = () => {
        return (
            <>
                <AmlReportDateInformation inserted={this.state.data.insertedFormated} completed={this.state.data.completedFormated} profile={this.state.data.amlProfileName} />
                <div className="alone-section">
                    <OldStyleSection name={this.props.translate("Alerts.Identification")} hasData={this.state.data.basicInformations} isOpen isBold>
                        <div className="card">
                            <div className="card-body">
                                <IdentData data={this.state.data.basicInformations} />
                            </div>
                        </div>
                    </OldStyleSection>
                </div>
            </>
        );
    }

    renderAmlData() {
        return (
            <div className="aml-available">
                <div className="columns">
                    <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                        <SvgRefresh className="refresh-icon" />
                        <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.updateData()}>
                            <Translate id="Report.Aml.UpdateData" />
                        </div>
                    </div>
                </div>
                <AmlGlobalEval data={this.state.data} decision={this.state.data.decision} />
                <OldStyleSection name={this.props.translate("Report.Aml.AmlPath")} hasData isOpen isBold>
                    <table id={"amlPathTable"} className={classnames("table old-style-table-report aml-path-table with-ellipsed-column ess-group")}>
                        <thead className="group-data-relations-header">
                            <tr>
                                <th className="col-1"><Translate id="Report.EconomicGroup.EconomicGroupLevel" /></th>
                                <th className="col-2"><Translate id="Report.EconomicGroup.EconomicGroupNegativeInfo" /></th>
                                <th><Translate id="Report.EconomicGroup.EconomicGroupRelationType" /></th>
                                <th>AML</th>
                            </tr>
                        </thead>
                        <tbody className={'old-style-stripped'}>
                            {this.renderPathLayers(this.state.data.path)}
                        </tbody>
                    </table>
                </OldStyleSection>
                <div id="detailSectionId">
                    <OldStyleSection name={this.props.translate("Report.Aml.AmlDetail")} hasData={!isNullOrUndefined(this.state.allPositiveData) && this.state.allPositiveData.length > 0} isOpen isBold>
                        <AmlDetailData
                            fontAwesomeIconName="chart-line"
                            data={this.state.allPositiveData}
                            isSection={true}
                            methodology={this.state.data.methodology}
                            share={this.state.data.share}
                            hideRatioFilter={false}
                            isOnPath
                        />
                    </OldStyleSection>
                </div>
                <AmlExplanatoryNotes2 data={this.state.data} />
            </div >
        );
    }

    chooseSubject = (subject) => {
        this.setState({ ...this.state, subject: new Array(subject) });
        this.scrollToDetailSection();
    }

    scrollToDetailSection() {
        var row = document.getElementById("detailSectionId");
        row.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
    }

    getName = (subject) => subject.type === "C" ? subject.name : subject.name + " " + subject.surname;

    getPositiveSubjects = (model, current, superiorId = null) => {
        let currentSubject = this.getCurrentSubject(current, superiorId);
        let positiveData = [];
        if (currentSubject.amlReport.decision != 'GREEN') {
            positiveData = [{ relation: null, subject: currentSubject }];
        }

        positiveData = positiveData.concat(currentSubject.relations.map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } }).filter(x => x.subject.amlReport.decision != 'GREEN'));
        current.relations.forEach(rel => {
            positiveData = positiveData.concat(this.getPositiveSubjects(model, rel, current.ChildId == superiorId ? current.ParentId : current.ChildId));
        });
        return positiveData;
    }

    reduceAndSavePositiveSubjects = (data) => {
        let positiveData = data.reduce((subj, rel) => {
            const { relation, subject } = rel;
            const entityId = subject.entityId;
            if (!subj[entityId]) {
                subj[entityId] = { subject, relation: [relation] };
            } else {
                subj[entityId].relation.push(relation);
            }
            return subj;
        }, []);

        this.setState({ allPositiveData: positiveData });
    }

    getCurrentSubject = (currentData, superiorId = null) => {
        if (isNullOrUndefined(superiorId)) {
            return this.state.data.subjects.filter(x => x.entityId == currentData.ParentId)[0];
        } else if (currentData.ChildId == superiorId) {// Childs
            return this.state.data.subjects.filter(x => x.entityId == currentData.ParentId)[0];
        } else {
            return this.state.data.subjects.filter(x => x.entityId == currentData.ChildId)[0];
        }
    }

    renderPathLayers = (currentData, superiorId = null, maxLevel = null) => {
        let currentSubject = this.getCurrentSubject(currentData, superiorId);
        maxLevel = this.findMaxLevel(currentData);

        let statutories = currentSubject.relations.filter(rel => rel.RelationType === 'S' && !rel.RelationCode.startsWith('NRBO')).map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });
        let keyOwners = currentSubject.relations.filter(rel => rel.RelationType === 'K').map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });
        let beneficiary = currentSubject.relations.filter(rel => rel.RelationType === 'S' && rel.RelationCode.startsWith('NRBO')).map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });

        let finalOwners = currentSubject.relations.filter(rel => rel.RelationType === 'F').map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });
        let publicFunction = currentSubject.relations.filter(rel => rel.RelationType === 'P').map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });
        let supervisoryBoard = currentSubject.relations.filter(rel => rel.RelationType === 'B').map((rel) => { return { relation: rel, subject: this.state.data.subjects.filter(sub => sub.entityId === rel.ParentId)[0] } });

        let currentRelationName = !isNullOrUndefined(currentData.RelationName) ? currentData.RelationName : null;
        if (!isNullOrUndefined(currentRelationName))
            currentRelationName += !isNullOrUndefined(currentData.Share) ? "(" + currentData.Share + "%)" : "";

        return (
            <React.Fragment key={currentSubject.entityId}>
                <>
                    <tr key={currentSubject.entityId} className={`colorize ${this.getRowColorClass(currentData.Level, maxLevel)}`}>
                        <td className='ellipsed-column'>
                            <div data-level={currentData.Level} style={{ display: 'flex', flexWrap: "nowrap" }}>
                                <RelationLink entityId={currentSubject.entityId} entityName={this.getName(currentSubject)} reports={currentSubject.reports} showOnMobile={true} />
                                &nbsp;<PngFlag countryCode={currentSubject.country} title={currentSubject.country} />&nbsp;
                                {this.renderEntityIdentification(currentSubject.birthDate, currentSubject.birthDateFormatted, currentSubject.companyId)}
                            </div>
                        </td>
                        <td></td>
                        <td>{currentRelationName}</td>
                        <td style={{ textAlign: "center" }}><Semaphore color={currentSubject.amlReport.decision.toLowerCase()} width={20} height={20} /></td>
                    </tr>
                    {currentSubject.type == "C" && (currentSubject.country == "SK" || currentSubject.country == "CZ") &&
                        <tr>
                            <td colSpan={4}>
                                <AmlStatutoriesEval fontAwesomeIconName="chart-line"
                                    data={statutories}
                                    isSection={true}
                                    methodology={this.state.data.methodology}
                                    share={this.state.data.share}
                                    hideRatioFilter={false}
                                    isOnPath
                                    chooseSubject={this.chooseSubject}
                                />
                                <AmlKeyOwnersEval
                                    data={keyOwners}
                                    section="keyOwners"
                                    hideRatioFilter={true}
                                    isOnPath
                                    chooseSubject={this.chooseSubject}
                                />

                                <AmlBeneficialOwnersEval
                                    data={beneficiary}
                                    section="beneficialOwners"
                                    hideRatioFilter={this.props.hideRatioFilter}
                                    isOnPath
                                    chooseSubject={this.chooseSubject}
                                    finalOwnerNegativeInfoText={(isNullOrUndefined(beneficiary) || beneficiary.length == 0) && this.state.data.entitiesWithNSWarning.includes(currentSubject.entityId) ? this.state.data.negativeInfoText : null}
                                />

                        <AmlFinalOwnersEval
                            data={finalOwners}
                            methodology={this.state.data.methodology}
                            share={this.state.data.share}
                            hideRatioFilter={true}
                            section="finalOwners"
                            isOnPath
                            chooseSubject={this.chooseSubject}
                        />

                                <AmlPublicFunctionsEval
                                    data={publicFunction}
                                    section="publicFunctionsEval"
                                    hideRatioFilter={this.props.hideRatioFilter}
                                    chooseSubject={this.chooseSubject}
                                    isOnPath
                                />

                                <AmlSupervisoryBoardEval
                                    data={supervisoryBoard}
                                    section="supervisoryBoard"
                                    hideRatioFilter={this.props.hideRatioFilter}
                                    chooseSubject={this.chooseSubject}
                                    isOnPath
                                />
                            </td>
                        </tr>
                    }
                </>
                {currentData.relations.map(rel => this.renderPathLayers(rel, currentData.ChildId == superiorId ? currentData.ParentId : currentData.ChildId, maxLevel))}
            </React.Fragment>
        );
    }

    findMaxLevel = (data) => {
        let maxLevel = 0;
        let relations = [];

        data.relations.forEach(rel => relations.push(rel));

        while (relations.length > 0) {
            let currentRelation = relations.pop();

            if (currentRelation.Level > maxLevel)
                maxLevel = currentRelation.Level;

            currentRelation.relations.forEach(rel => relations.push(rel));
        }

        return maxLevel;
    }

    renderEntityIdentification = (birthDate, birthDateFormated, companyId) => {
        if (isNullOrUndefined(birthDate) && (isNullOrUndefined(companyId) || companyId.length === 0))
            return null;

        return <>({birthDate !== null && birthDate !== undefined ? birthDateFormated : companyId})</>
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(this.state.data) && !isNullOrUndefined(this.state.data.entityId) && isNullOrUndefined(this.props.entity.entityInfos[this.state.data.entityId])) {
            this.props.ensureEntityInfo(this.state.data.entityId);
        }
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.getData();
        }
    }

    getRowColorClass = (level, maxLevel) => {
        let color = 19;

        if (maxLevel > 19)
            maxLevel = 19;

        if (level > 19)
            level = 19;

        if (level > maxLevel)
            level = maxLevel;

        if (maxLevel < 5)
            color = 10 + Math.floor(10 / maxLevel) * level;
        else if (maxLevel >= 5 && maxLevel < 10)
            color = 1 + Math.floor(20 / maxLevel) * level;
        else
            color = (20 - maxLevel) + level;

        return `color-${color}`;
    }

    requestData() {
        this.setState({ loading: true });
        this.props.setResultsRequestParams(REGISTRY.aml, null);

        if (this.props.asReport === true) {
            apiPost(`${window.babylonApiUrl}/api/report/${this.props.match.params.id}/aml-info-check`, null, null,
                () => this.getData(),
                () => { });
        }
    }

    getData() {
        this.setState({ loading: true });
        this.props.setResultsRequestParams(REGISTRY.aml, null);

        if (this.props.asReport === true) {
            apiGet(`${window.babylonApiUrl}/api/search/aml/request-path/report/${this.props.match.params.id}`, null,
                (res) => {
                    this.onSuccess(res.data);
                    this.setState({ dataHash: getDataHash(res.data) })
                },
                () => { })
        } else {
            apiGet(`${window.babylonApiUrl}/api/search/aml/request-path/${this.props.match.params.id}`, null, (res) => this.onSuccess(res.data), () => { })
        }
    }

    areAvailable = (data) => data.reportStatus === amlReportStatus.available;

    onSuccess = (data) => {
        this.setState({ data: data, loading: false });

        if (!isNullOrUndefined(data)) {
            let foundSubjects = this.getPositiveSubjects(data, data.path);
            this.reduceAndSavePositiveSubjects(foundSubjects);

            if (this.props.asReport === true) {
                this.props.setResultsRequestParams(REGISTRY.aml,
                    this.areAvailable(data) ? { subPath: 'request-path', id: parseInt(this.props.match.params.id), params: { asReport: this.props.asReport === true } } : null
                );
            } else {
                this.props.setResultsRequestParams(REGISTRY.aml, { subPath: 'request-path', id: parseInt(this.props.match.params.id), params: null });
            }
        }
    }

    getSearchData(updateData = false) {
        if (updateData) {
            return {
                ico: this.state.data.basicInformations.companyId,
                country: this.state.data.country,
                share: this.state.data.share,
                oldRequestDate: this.state.data.inserted
            };
        }

        return {
            ico: this.state.data.basicInformations.companyId,
            country: this.state.data.country,
            share: this.state.data.share,
        };
    }

    updateData() {
        var generatedDataForServer = this.getSearchData(true);
        generatedDataForServer.oldRequestDate = this.state.data.completed;
        apiPost(
            `${window.babylonApiUrl}/api/search/aml/check/path`,
            null,
            generatedDataForServer,
            (res) => {
                if (res.data.isSuccess) {
                    if (isNullOrUndefined(res.data.id))
                        this.confirmationPopup();
                    else {
                        const path = `/search/aml/results/path/${res.data.id}`;
                        if (res.data.isCustomerRequest)
                            this.decisionPopup(generatedDataForServer, res.data.requestDateFormatted, path);
                        else
                            this.confirmationPopup();
                    }
                }
                else
                    this.onError(res.data);
            },
            (err) => this.onError(err.data)
        );
    }

    confirmationPopup() {
        this.props.showPopup('updateAmlData', {
            open: true,
            close: () => this.props.hidePopup(),
            onSubmitAmlRequest: () => this.initiateRequest(),
            data: this.state.data,
            asCompany: true
        });
    }

    initiateRequest() {
        var searchData = this.getSearchData();
        searchData.forceNewRequest = true;
        this.props.initiateCeeRequestOnPo(REGISTRY.aml, REGISTRY.aml, searchData, true);
        this.setState({ refreshReqInit: true });
    }

    decisionPopup = (generatedDataForServer, requestDate, continuePath) => {
        this.props.showPopup('ceeDecision', {
            title: this.props.translate('Common.Information'),
            open: true,
            close: () => { this.props.hidePopup(); },
            requestDate: requestDate,
            continue: () => {
                //re-use the old request  
                if (!isNullOrUndefined(continuePath) && continuePath !== '')
                    this.props.history.push(continuePath);
                else
                    this.props.hidePopup();
            },
            newRequest: () => {
                this.props.hidePopup();
                generatedDataForServer.forceNewRequest = true;
                //check credit to get accurate price and create a new request
                apiPost(
                    `${window.babylonApiUrl}/api/search/aml/check/po`,
                    null,
                    generatedDataForServer,
                    (res) => {
                        if (res.data.isSuccess) {
                            if (isNullOrUndefined(res.data.requestId))
                                this.confirmationPopup();
                            else
                                this.props.history.push(continuePath);
                        } else
                            this.onError(res.data);
                    },
                    (err) => this.onError(err.data)
                );
            }
        });
    }

    onError = (data) => this.setState({ responseData: data });

    renderErrors = () => {
        const resData = this.props.cee[REGISTRY.aml].responseData;
        const stateResData = this.state.responseData;

        if (this.props.cee[REGISTRY.aml].requestResult === false && this.hasError(resData) || this.hasError(stateResData)) {
            return (
                <div style={{ marginTop: "1em" }}>
                    {((!isNullOrUndefined(resData) && !isNullOrUndefined(resData.exception)) || (!isNullOrUndefined(stateResData) && !isNullOrUndefined(stateResData.exception))) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.exception
                                ? <Translate options={{ renderInnerHtml: true }} id={stateResData.exception} data={isNullOrUndefined(stateResData.exceptionData) ? undefined : stateResData.exceptionData} />
                                : <Translate options={{ renderInnerHtml: true }} id={resData.exception} data={isNullOrUndefined(resData.exceptionData) ? undefined : resData.exceptionData} />}
                        </Message>}

                    {((!isNullOrUndefined(resData) && !!resData.error) || (!isNullOrUndefined(stateResData) && !!stateResData.error)) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.error
                                ? <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(stateResData.error.message) ? stateResData.error : stateResData.error.message} />
                                : <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(resData.error.message) ? resData.error : resData.error.message} />}
                        </Message>}
                </div>
            );
        }
    }

    hasError = (data) => !isNullOrUndefined(data) && (!isNullOrUndefined(data.exception) || !isNullOrUndefined(data.errorFile) || !!data.error);
}

export default withLocalize(connect(
    state => { return { cee: state.registrySearch, user: state.userContext } },
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions }, dispatch)
)(AmlPath));
